import React, { useEffect, useState } from "react";
import styles from "../offlinePay.module.css";
import OfflineStudentForm from "./OfflineStudentForm";
import OfflineStudentDocs from "./OfflineStudentDocs";
import { fetchDetails, statusApi } from "../../../api";
import { useMyContext } from "../../../myContext";

function OfflineStudent({ stepToShowOffline, setStepToShowOffline }) {
  const [loading, setLoading] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [studentDetail, setStudentDetail] = useState();
  const [documentUploaded, setDocumentUploaded] = useState(false);
  const {setOfflineStudentUserId, themeColor} = useMyContext();

  useEffect(() => {
    fetchStudentData();
  },[])

  const fetchStudentDetail = async(id) => {
    try{
      const resp = await statusApi(id);
      setStudentDetail(resp?.data);
      if(resp?.data?.documents?.PASSPORT_BACK?.status === "Verified" && resp?.data?.documents?.PASSPORT_FRONT?.status === "Verified")
      setDocumentUploaded(true)
      setLoading(false);
    }
    catch(e){
      setLoading(false);
    }
  }

  const fetchStudentData = async () => {
    setLoading(true);
    try {
      fetchDetails("student").then((response) => {
        if(response?.data.length > 0){
          setStudentList(response?.data);
          fetchStudentDetail(response?.data[0].userAccountId);
          setOfflineStudentUserId(response?.data[0].userAccountId);
        } else{
          setLoading(false);
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className={styles.cardDetails}>
      <>
        <h1 className={styles.onboardHeading}>2. Student</h1>
          <OfflineStudentForm
            stepToShowOffline={stepToShowOffline}
            setStepToShowOffline={setStepToShowOffline}
            studentList={studentList} 
            documentUploaded={documentUploaded}
            studentDetail={studentDetail}
          />
         {!documentUploaded && <OfflineStudentDocs stepToShowOffline={stepToShowOffline} setStepToShowOffline={setStepToShowOffline}/>}
      </>
    </div>
  );
}

export default OfflineStudent;
